import { ApiStatus } from "../types/api/status"
import { useDispatch } from "../redux/store"
import { CustomSnackbar } from "../components/common/CustomSnackbar/CustomSnackbar"
import { readLocalStorage } from "../toolbox/helpers/local-storage-helpers"
import { LocalStorageKey } from "../types"
import { UserERPAPI } from "../apis/UserERPApi"

export const useUserErpStore = () => {

  const dispatch = useDispatch()
 
  const userData = readLocalStorage(LocalStorageKey.USER_DATA)
  const idcompany = userData?.idcompany

  const getVerifyERP = async (iduser) => {
    try {
    //   dispatch(changeStatus(ApiStatus.FETCHING))
      const response = await UserERPAPI.getVerifyERP(iduser)
      if (!response?.status) {
        // dispatch(changeStatus(ApiStatus.FETCHED))
        CustomSnackbar('error', response.data.message || "");
        return false; 
      }
      const { detail } = response.data
    //   dispatch(changeStatus(ApiStatus.FETCHED))
      return detail;
    } catch (error) {
      console.log(error)
    //   return dispatch(changeStatus(ApiStatus.FETCHED))
    }
  }

  const createUserERP = async (data: any) => {
    try {
    //   dispatch(changeStatus(ApiStatus.FETCHING))
      const response = await UserERPAPI.createUserERP(data)
      if (!response?.status) {
        // dispatch(changeStatus(ApiStatus.FETCHED))
        CustomSnackbar('error', response.data.message || "");
        return false;
      }
    //   dispatch(changeStatus(ApiStatus.FETCHED))
      CustomSnackbar('success', response.data.message  || "");
      return true;
    } catch (error) {
      console.log(error)
    //   return dispatch(changeStatus(ApiStatus.FETCHED))
    }
  }

  const editUserERP = async (iduser: number, data: any) => {
    try {
    //   dispatch(changeStatus(ApiStatus.FETCHING))
      const response = await UserERPAPI.editUserERP(iduser, data)
      if (!response?.status) {
        // dispatch(changeStatus(ApiStatus.FETCHED))
        CustomSnackbar('error', response.data.message || "");
        return false;
      }
    //   dispatch(changeStatus(ApiStatus.FETCHED))
      CustomSnackbar('success', response.data.message  || "");
      return true;
    } catch (error) {
      console.log(error)
    //   return dispatch(changeStatus(ApiStatus.FETCHED))
    }
  }

  const deleteUserERP = async (iduser: number) => {
    try {
    //   dispatch(changeStatus(ApiStatus.FETCHING))
      const response = await UserERPAPI.deleteUserERP(iduser)
      if (!response?.status) {
        // dispatch(changeStatus(ApiStatus.FETCHED))
        CustomSnackbar('error', response.data.message || "");
        return false;
      }
    //   dispatch(changeStatus(ApiStatus.FETCHED))
      CustomSnackbar('success', response.data.message  || "");
      return true;
    } catch (error) {
      console.log(error)
    //   return dispatch(changeStatus(ApiStatus.FETCHED))
    }
  }

  return {
    //states
    //actions
    getVerifyERP,
    createUserERP,
    editUserERP,
    deleteUserERP,
  }
}